import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
export function usePaginatedActivitiesQuery(skip, numItems) {
  const $ = _c(18);
  const [currentCursor, setCurrentCursor] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [cursorHistory, setCursorHistory] = useState(t0);
  let t1;
  if ($[1] !== currentCursor || $[2] !== numItems || $[3] !== skip) {
    t1 = skip ? "skip" : {
      paginationOpts: {
        numItems,
        cursor: currentCursor
      }
    };
    $[1] = currentCursor;
    $[2] = numItems;
    $[3] = skip;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const data = useQuery(api.activities.get, t1);
  const activities = data?.page;
  const hasNextPage = data ? !data.isDone : false;
  const hasPreviousPage = cursorHistory.length > 0;
  let t2;
  if ($[5] !== currentCursor || $[6] !== cursorHistory || $[7] !== data) {
    t2 = () => {
      if (data?.continueCursor) {
        setCursorHistory([...cursorHistory, currentCursor]);
        setCurrentCursor(data.continueCursor);
      }
    };
    $[5] = currentCursor;
    $[6] = cursorHistory;
    $[7] = data;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const goToNextPage = t2;
  let t3;
  if ($[9] !== cursorHistory) {
    t3 = () => {
      const newHistory = [...cursorHistory];
      const previousCursor = newHistory.pop();
      setCursorHistory(newHistory);
      setCurrentCursor(previousCursor ?? null);
    };
    $[9] = cursorHistory;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const goToPreviousPage = t3;
  const t4 = data === undefined;
  let t5;
  if ($[11] !== activities || $[12] !== goToNextPage || $[13] !== goToPreviousPage || $[14] !== hasNextPage || $[15] !== hasPreviousPage || $[16] !== t4) {
    t5 = {
      activities,
      isLoading: t4,
      hasNextPage,
      hasPreviousPage,
      goToNextPage,
      goToPreviousPage
    };
    $[11] = activities;
    $[12] = goToNextPage;
    $[13] = goToPreviousPage;
    $[14] = hasNextPage;
    $[15] = hasPreviousPage;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}